import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ApplicationState } from "@idw-types/state/application-state";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { SecurityRuleDetailsComponent } from "./security-rule-details-component/security-rule-details-component";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { getSecurityRulesReduxRequest } from "@redux-requests/security-rules";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";

export const SecurityRuleDetailsContainer = () => {
    const dispatch = useDispatch();
    const { axnAdminSecurityRuleId } = useParams<{ axnAdminSecurityRuleId: string }>();

    const {
        isLoadingAxnAdminSecurityRules,
        axnAdminSecurityRules
    } = useSelector((state: ApplicationState) => ({
        isLoadingAxnAdminSecurityRules: state.securityRules.securityRules.isLoading,
        axnAdminSecurityRules: state.securityRules.securityRules.securityRules
    }));

    const [isDisabled, setIsDisabled] = useState(true);
    const [shouldLoadAxnAdminSecurityRules, setShouldLoadAxnAdminSecurityRules] = useState(true);

    useEffect(() => {
        if (!isLoadingAxnAdminSecurityRules && shouldLoadAxnAdminSecurityRules) {
            setShouldLoadAxnAdminSecurityRules(false);
            getSecurityRulesReduxRequest(dispatch)();
        }
    }, [isLoadingAxnAdminSecurityRules, shouldLoadAxnAdminSecurityRules]);

    const isLoading = useMemo(() => {
        return isLoadingAxnAdminSecurityRules;
    }, [isLoadingAxnAdminSecurityRules]);

    const isLoaded = useMemo(() => {
        return !!(
            !isLoading &&
            axnAdminSecurityRules &&
            !shouldLoadAxnAdminSecurityRules
        );
    }, [isLoading, axnAdminSecurityRules, shouldLoadAxnAdminSecurityRules]);

    const axnAdminSecurityRule = useMemo(() => {
        if (axnAdminSecurityRules) {
            return axnAdminSecurityRules.find(sr => sr.id === axnAdminSecurityRuleId);
        } else {
            return null;
        }
    }, [axnAdminSecurityRules]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.securityRuleDetails.header} />
            <ContentPageBody isMaxWidth={true}>
                {isLoaded && axnAdminSecurityRule && (
                    <SecurityRuleDetailsComponent
                        securityRule={axnAdminSecurityRule}
                        securityRules={axnAdminSecurityRules}
                        isDisabled={isDisabled}
                        setIsDisabled={setIsDisabled}
                    />
                )}
                {isLoading && (
                    <LoadingIndicator title={resources.common.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};